import React from 'react';
import { ListStore } from 'shared/stores/ListStore';
import { observer } from 'mobx-react';
import JobPositionChangelogTable from './JobPositionChangelogTable';
import { jobPositionChangelogStore } from './JobPositionChangelogStore';
import { Pagination } from 'ats/components/pagination/Pagination';
import Dropdown from 'ats/components/dropdown/Dropdown';
import ChangelogEmptyState from 'ats/components/empty-state/ChangelogEmptyState';

@observer
export class JobPositionChangelog extends React.Component {
	constructor(props) {
		super(props);
		this.listStore = new ListStore(jobPositionChangelogStore, {
			entityName: 'Job Position Changelog'
		});
		this.listStore.beginLoading();
	}

	componentDidMount() {
		if (this.props.jobPosition?.id) {
			jobPositionChangelogStore.setQuery('jobId', this.props.jobPosition.id);
			jobPositionChangelogStore.setQuery('sort', {
				column: 'createdAt',
				asc: false
			});
			this.listStore.search();
		}
	}

	componentDidUpdate(prevProps) {
		const { jobPosition } = this.props;

		if (prevProps.jobPosition?.id !== jobPosition?.id && jobPosition?.id) {
			jobPositionChangelogStore.setQuery('jobId', jobPosition.id);
			jobPositionChangelogStore.setQuery('sort', {
				column: 'createdAt',
				asc: false
			});
			this.listStore.search();
		}
	}

	handlePaginationChange = value => {
		this.listStore.handlePaginationChange(
			value,
			this.listStore.store.query.pagination.limit
		);
	};

	render() {
		const typeFilterDropdown = (
			<Dropdown
				value={this.listStore.store.query.columnName}
				name="columnName"
				onChange={newValue => {
					this.listStore.store.setQuery('columnName', newValue);
					this.handlePaginationChange(1);
				}}
				optionValue="value"
				options={[
					{ label: 'All', value: null },
					...jobPositionChangelogStore.typeOptions
				]}
				placeholder="All"
				displayValue={value => `Type: ${value}`}
			/>
		);

		const showEmptyState =
			!this.listStore.loading && this.listStore.data.length === 0;
		const hasEntries = this.listStore.data.length > 0;

		return (
			<div className="job-position-changelog-tab">
				<div className="job-position-tab-section-header job-position-changelog-section-header">
					<div className="job-position-tab-section-title">Log</div>
					<div className="table-action-buttons job-position-changelog-header-tools">
						<Pagination
							loading={this.listStore.loading}
							pagination={this.listStore.store.query.pagination}
							onPaginationChange={this.handlePaginationChange}
							hidePageControls
							customButton={typeFilterDropdown}
						/>
					</div>
				</div>
				<div className="job-position-changelog">
					<JobPositionChangelogTable
						data={this.listStore.data}
						sort={this.listStore.store.query.sort}
						onSort={this.listStore.handleSort}
						isEmpty={showEmptyState}
						loading={this.listStore.loading}
						emptyState={<ChangelogEmptyState />}
					/>
					{hasEntries ? (
						<Pagination
							loading={this.listStore.loading}
							pagination={this.listStore.store.query.pagination}
							onPaginationChange={this.handlePaginationChange}
							hideLimitSelect
						/>
					) : null}
				</div>
			</div>
		);
	}
}
